module.exports = __webpack_public_path__ + "img/SpamTitan.35f8a818.svg";